module.exports = __webpack_public_path__ + "static/fonts/Fact-MediumItalic.f707ede.woff2";